import TagManager from "react-gtm-module"

export function initGTM(userId: string, userType: string, portal = `motor`) {
  if (isProd()) {
    TagManager.initialize({
      gtmId: `GTM-WVRQJRB`,
      dataLayer: {
        userId,
        userType,
        portal,
      },
    })
  }
}

export function isProd(): boolean {
  const currentURL = window.location.href
  if (currentURL.includes(`localhost`)) {
    return false
  }
  if (currentURL.includes(`prod.infra.flockcover`)) {
    return true
  }
  return true
}
